module.exports = __webpack_public_path__ + "static/media/feature_5.723049cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_5.png
// module id = 1254
// module chunks = 0